import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AuthInterceptor } from '@timechef/core/auth';
import { SINK_PROVIDERS } from '@timechef/core/logging';
import { SharedModule } from '@timechef/shared';
import { environment } from 'src/environments/environment';
import { SwiperModule } from 'swiper/angular';
import { GA_CONFIG_PROVIDERS } from './analytics';
import { PlateformeInterceptor } from './interceptors/plateforme.interceptor';

import { ApiClientModule, ApiConfiguration } from './api';
import { appInitializer } from './config';
import { FabMenuComponent } from './containers/fab-menu/fab-menu.component';
import { LogsModalComponent } from './containers/logs-modal/logs-modal.component';
import { StoreInspectorModalComponent } from './containers/store-inspector-modal/store-inspector-modal.component';
import { ErrorHandlerService } from './errors/error-handling.service';
import { AcceptLanguageInterceptor } from './i18n';
import { translocoInitializer } from './i18n/transloco-initializer';

const exported = [FabMenuComponent, LogsModalComponent, StoreInspectorModalComponent];

@NgModule({
  declarations: [...exported],
  exports: [...exported, ApiClientModule],
  imports: [CommonModule, IonicModule, ApiClientModule, RouterModule, SharedModule, SwiperModule],
  providers: [
    ...SINK_PROVIDERS,
    ...GA_CONFIG_PROVIDERS,
    translocoInitializer,
    {
      provide: ApiConfiguration,
      useFactory: apiConfigurationFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AcceptLanguageInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PlateformeInterceptor,
      multi: true,
    },
    appInitializer,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}

function apiConfigurationFactory() {
  const apiConfiguration = new ApiConfiguration();
  apiConfiguration.rootUrl = environment.apiUrl;
  return apiConfiguration;
}
